import { render } from "./ConfirmAction.vue?vue&type=template&id=1e20cfe0"
import script from "./ConfirmAction.vue?vue&type=script&lang=js"
export * from "./ConfirmAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__